// 站点根域名与 canonical 拼接（与 PDF 要求 gbofficial.net 对齐）
export const SITE_ORIGIN = 'https://gbofficial.net'

/**
 * @param {string} pathname 以 / 开头，建议带尾部斜杠与 sitemap 一致
 */
export function siteCanonical(pathname) {
	if (!pathname || pathname === '/') {
		return `${SITE_ORIGIN}/`
	}
	const withLeading = pathname.startsWith('/') ? pathname : `/${pathname}`
	const withSlash = withLeading.endsWith('/') ? withLeading : `${withLeading}/`
	return `${SITE_ORIGIN}${withSlash}`
}
